import '.cp{position:relative;}.ssr-plugin'
import '.b2{background-color:var(--palette-white);}.ssr-plugin'
import '.i4{border-radius:20px;}.ssr-plugin'
import '.b7{border:var(--border-subtle);}.ssr-plugin'
import '.cd{padding:1.5rem;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.j1{transition:box-shadow 0.2s ease;}.ssr-plugin'
import '.fi{width:2rem;}.ssr-plugin'
import '.fj{height:2rem;}.ssr-plugin'
import '.ex{border-radius:50%;}.ssr-plugin'
import '.j2{border:1px solid var(--palette-blue-800);}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.e{flex-shrink:0;}.ssr-plugin'
import '.j3{margin-left:1rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'

export interface SubsidyCardProps {
  title: string
  description: string
  style?: Style
  onClick?: () => void
}

export const SubsidyCard = ({
  title,
  description,
  style,
  onClick,
}: SubsidyCardProps) => {
  return (
    <styled.div className="cp b2 i4 b7 cd h j1"
      data-testid="subsidy-card"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.08)',
            }
          : {},
        ...style,
      }}
    >
      <Column gap="0.625rem" alignItems="stretch">
        {/* Header Section */}
        <Row
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {/* Title */}
          <Title.H5 style={{ color: 'var(--palette-blue-800)' }}>
            {title}
          </Title.H5>

          {/* Circular Icon */}
          <div className="fi fj ex j2 l a1 aa e j3"
          >
            <FontAwesomeIcon
              icon={faArrowUpRight}
              style={{
                color: 'var(--palette-blue-800)',
                height: '1.25rem',
              }}
            />
          </div>
        </Row>

        {/* Body Section */}
        <Text.Medium
          style={{
            color: 'var(--palette-blue-600)',
          }}
        >
          {description}
        </Text.Medium>
      </Column>
    </styled.div>
  )
}
